<ui-modal [abierto]="abierto()" titulo="Mi perfil" subtitulo="Información de SIGERH" (cerrar)="cerrarModal()">
  @if (usuario(); as u) {
    <!-- Identidad -->
    <div class="flex items-center gap-4">
      <div class="flex size-14 shrink-0 items-center justify-center rounded-full bg-primary-500 text-lg font-bold text-white">
        {{ iniciales() }}
      </div>
      <div class="min-w-0">
        <p class="truncate text-base font-bold text-gray-900 dark:text-gray-100">{{ nombre() }}</p>
        <p class="truncate text-sm text-gray-500 dark:text-gray-400">{{ u.username }} · {{ rol() }}</p>
      </div>
    </div>

    <!-- Datos de RRHH -->
    <dl class="mt-5 grid grid-cols-1 gap-x-6 gap-y-3 text-sm sm:grid-cols-2">
      @if (u.email) {
        <div>
          <dt class="text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">Correo</dt>
          <dd class="mt-0.5 break-all text-gray-800 dark:text-gray-200">{{ u.email }}</dd>
        </div>
      }
      @if (u.detalles?.cargo) {
        <div>
          <dt class="text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">Cargo</dt>
          <dd class="mt-0.5 text-gray-800 dark:text-gray-200">{{ u.detalles?.cargo }}</dd>
        </div>
      }
      @if (u.detalles?.departamento) {
        <div>
          <dt class="text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">Unidad</dt>
          <dd class="mt-0.5 text-gray-800 dark:text-gray-200">{{ u.detalles?.departamento }}</dd>
          @if (u.detalles?.departamentoId) {
            <dd class="mt-0.5 break-all font-mono text-xs text-gray-500 dark:text-gray-400">{{ u.detalles?.departamentoId }}</dd>
          }
        </div>
      }
      @if (u.detalles?.telefono) {
        <div>
          <dt class="text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">Teléfono</dt>
          <dd class="mt-0.5 text-gray-800 dark:text-gray-200">{{ u.detalles?.telefono }}</dd>
        </div>
      }
      @if (u.detalles?.modalidad) {
        <div>
          <dt class="text-xs font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">Modalidad</dt>
          <dd class="mt-0.5 text-gray-800 dark:text-gray-200">{{ u.detalles?.modalidad }}</dd>
        </div>
      }
    </dl>

    <!-- Firma -->
    <div class="mt-6 border-t border-gray-100 pt-5 dark:border-gray-800">
      <div class="flex items-center justify-between gap-3">
        <div>
          <h4 class="text-sm font-bold text-gray-900 dark:text-gray-100">Firma</h4>
          <p class="mt-0.5 text-xs text-gray-500 dark:text-gray-400">
            Se guarda para usarla en informes y documentos del laboratorio.
          </p>
        </div>
        @if (!editando()) {
          @if (u.firma) {
            <div class="flex shrink-0 gap-2">
              <button type="button" uiButton size="sm" (click)="iniciarEdicion()">Cambiar</button>
              <button type="button" uiButton variant="danger" size="sm" [disabled]="guardando()" (click)="quitarFirma()">
                Quitar
              </button>
            </div>
          } @else {
            <button type="button" uiButton variant="primary" size="sm" class="shrink-0" (click)="iniciarEdicion()">
              Agregar firma
            </button>
          }
        }
      </div>

      @if (error()) {
        <div class="mt-3">
          <ui-alert>{{ error() }}</ui-alert>
        </div>
      }

      @if (!editando() && u.firma) {
        <!-- Fondo blanco fijo: la firma es tinta oscura y debe verse también en modo oscuro. -->
        <div class="mt-3 rounded-lg border border-gray-200 bg-white p-3 dark:border-gray-700">
          <img [src]="u.firma" alt="Firma guardada" class="mx-auto max-h-28 max-w-full" />
        </div>
      }

      @if (editando()) {
        <div class="mt-3">
          <canvas
            #lienzo
            width="600"
            height="240"
            class="w-full cursor-crosshair touch-none rounded-lg border border-dashed border-gray-300 bg-white dark:border-gray-600"
            (pointerdown)="empezarTrazo($event)"
            (pointermove)="continuarTrazo($event)"
            (pointerup)="terminarTrazo()"
            (pointerleave)="terminarTrazo()"
          ></canvas>
          <p class="mt-1.5 text-xs text-gray-500 dark:text-gray-400">
            Dibuje su firma en el recuadro, o suba una imagen ya digitalizada.
          </p>
          <div class="mt-3 flex flex-wrap items-center gap-2">
            <button type="button" uiButton variant="primary" size="sm" [disabled]="!hayTrazo() || guardando()" (click)="guardarFirma()">
              {{ guardando() ? 'Guardando…' : 'Guardar firma' }}
            </button>
            <button type="button" uiButton size="sm" (click)="archivo.click()">Subir imagen</button>
            <input
              #archivo
              type="file"
              accept="image/png,image/jpeg,image/webp"
              class="hidden"
              (change)="subirImagen($event)"
            />
            <button type="button" uiButton variant="ghost" size="sm" [disabled]="!hayTrazo()" (click)="limpiarLienzo()">
              Limpiar
            </button>
            <button type="button" uiButton variant="ghost" size="sm" (click)="cancelarEdicion()">Cancelar</button>
          </div>
        </div>
      }
    </div>
  }

  <!--
    Versión desplegada de la aplicación. Va aquí porque es el dato que pide
    soporte cuando alguien reporta un problema, y el perfil es la pantalla que
    todo usuario tiene a mano.
  -->
  <div class="mt-6 border-t border-gray-200 pt-4 dark:border-gray-800">
    <p class="text-xs font-semibold tracking-wide text-gray-400 uppercase dark:text-gray-500">
      Acerca del sistema
    </p>
    <dl class="mt-3 text-sm">
      <div>
        <dt class="text-xs font-semibold tracking-wide text-gray-400 uppercase dark:text-gray-500">
          Aplicación web
        </dt>
        <dd class="mt-0.5 text-gray-800 dark:text-gray-200">
          <span class="font-semibold">{{ frontend.version }}</span>
          <span class="text-gray-500 dark:text-gray-400">
            · {{ frontend.branch }} · {{ commitCorto(frontend.commit) }}
          </span>
          <span class="block text-xs text-gray-500 dark:text-gray-400">
            Compilada el {{ fechaLegible(frontend.buildDate) }}
          </span>
        </dd>
      </div>
    </dl>
  </div>
</ui-modal>
